import { render } from "./OrderStats.vue?vue&type=template&id=39d018ee"
import script from "./OrderStats.vue?vue&type=script&lang=js"
export * from "./OrderStats.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\frval\\real-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__